import { RootState } from '@/store/store'

export const selectFeedbackReasons = (state: RootState) => state.responseFeedbackState.feedbackReasonsData

export const selectFeedbackReasonsLoading = (state: RootState) => state.responseFeedbackState.feedbackReasonsLoading

export const selectFeedbackReasonsError = (state: RootState) => state.responseFeedbackState.feedbackReasonsError
